/**
 * « Accès staff » d'un parc (étape 4 du chantier droits-multi-parcs,
 * .scratch/droits-multi-parcs/spec.md) : `zoo.staffAccess` est la copie des
 * registres du staff AKONGO, écrite par le serveur seul (les règles refusent
 * l'écriture du navigateur). Les écrans envoient l'ajout ou le retrait de chaque
 * membre par commande ; le serveur reprend le rôle de sa fiche et tient la liste.
 * Un membre encore sans registre (avant le rattrapage) y est tenu comme avant.
 */

const ids = (value) => (Array.isArray(value)
  ? [...new Set(value.filter((id) => typeof id === "string" && id))]
  : []);

/** Membres ajoutés et retirés entre la liste enregistrée et la liste voulue. */
export function staffAccessDelta(before, after) {
  const was = ids(before);
  const next = ids(after);
  return {
    added: next.filter((id) => !was.includes(id)),
    removed: was.filter((id) => !next.includes(id)),
  };
}

// Le serveur nomme le refus dans le message (AKONGO_ACCOUNT, NOT_ACTIVE…).
const failureCode = (error) => error?.message || error?.code || "ACCESS_COMMAND_FAILED";

/**
 * Une commande par membre, l'une après l'autre (toutes écrivent la fiche du
 * parc). Un échec n'arrête pas les suivantes : il est rendu dans `failed`.
 * `call(nom, données)` : la fonction appelable du serveur.
 */
export async function applyStaffAccessChanges({ zooId, before, after, call }) {
  const { added, removed } = staffAccessDelta(before, after);
  const failed = [];
  const run = async (name, uid, change) => {
    try {
      await call(name, { uid, zooId });
    } catch (error) {
      failed.push({ uid, change, code: failureCode(error) });
    }
  };
  for (const uid of added) await run("accessSetZooEntry", uid, "add");
  for (const uid of removed) await run("accessRevokeZoo", uid, "remove");
  return { added, removed, failed };
}
